import { render } from "./PCPay.vue?vue&type=template&id=77512b2c&scoped=true"
import script from "./PCPay.vue?vue&type=script&lang=js"
export * from "./PCPay.vue?vue&type=script&lang=js"

import "./PCPay.vue?vue&type=style&index=0&id=77512b2c&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77512b2c"]])

export default __exports__